module.exports = __webpack_public_path__ + "img/initial-page.81604ebd.png";